export default [
	'$sce',
	'$sanitize',
	function ($sce, $sanitize) {
		return function (val) {
			return $sce.getTrustedHtml($sanitize(val));
		};
	}
];
